// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__2aFAj","second":"return_second__1ap9L","link":"return_link__BP-Xx"};